// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// FAQ Module

// Get Faqs from Client and Server

define('Faq',['require','ReturnCodes','Server','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        ReturnCodes = require('ReturnCodes'),
        Server = require('Server'),
        Utilities = require('Utilities'),

        // Instance variables
        self,
        returnCodes,// Server status codes instance
        server,     // Server instance
        utilities,  // Utilities instance
        faqs,       // Map of FAQ Questions and Answers
        serverFaqs; // Map of FAQs from the server

    // Constructor
    function Faq () {
        // Preserve instance reference and enforce singleton
        if (typeof self === 'object') { return self; } else { self = this; }

        // Dependent Resources
        returnCodes = new ReturnCodes();
        utilities = new Utilities();

        // Get app specific parameters
        var appName = utilities.getApplicationName();

        // Define the list of client side FAQs
        faqs = [

            { section:  'Profile',
              importance: 1,
              question: 'How do I setup a login account for ' + appName + '?',
              answer:   'Setting up an account is really easy.  Click on ' +
                        'the menu button in the upper left and choose ' +
                        'Profile.  Enter your email, choose a password, ' +
                        'and indicate if someone referred you. You can also ' +
                        'choose to use your Facebook profile to login. ' +
                        'That\'s it. You will get an email back with a '+
                        'validation link. Click on the link and your account ' +
                        'is fully activated and you will then start to get ' +
                        'Mojo Points with each Score and other benefits.' },

            { section:  'Profile',
              importance: 2,
              question: 'What is a referral?',
              answer:   'When you create your ' + appName + ' login, you ' +
                        'can additionally provide the email address of ' +
                        'anyone that might have referred you to the app. ' +
                        'That user will get extra bonus Mojo Points for ' +
                        'the referral.  You too can get extra Mojo Points ' +
                        'for any referrals you make.  So, encourage your ' +
                        'friends to signup and give the app a try.' },

            { section:  'Profile',
              importance: 2,
              question: 'How do I change my email used for login?',
              answer:   'When you create your ' + appName + ' login, you ' +
                        'specify an email address to use as a username. ' +
                        'If you would like to change your email address, ' +
                        'select Profile from the menu button.  There is an ' +
                        'option to change your email in the first section. ' +
                        'When you change your email, you will need to enter ' +
                        'your existing password.' },

            { section:  'Profile',
              importance: 2,
              question: 'How do I change my password used for login?',
              answer:   'When you create your ' + appName + ' login, you ' +
                        'specify a valid password to use. If you would ' +
                        'like to change your password, select Profile ' +
                        'from the menu button.  There is an option to ' +
                        'change your password in the first section. For ' +
                        'safety, when you change your password, you will ' +
                        'need to enter your existing password first.' },

            { section:  'Profile',
              importance: 2,
              question: 'What if I forgot my password?',
              answer:   'When you forget your ' + appName + ' password, ' +
                        'you will need to reset it.  Select Profile from ' +
                        'menu button.  On the login view, there is an ' +
                        'option to Reset Password.  You will get an email ' +
                        'with further instructions to complete the process.' },

            { section:  'Profile',
              importance: 3,
              question: 'Which avatar name should I choose?',
              answer:   'Be creative!  Choose a colorful name that says ' +
                        'something about you.  Your avatar name will be ' +
                        'displayed with all your Score Comments, Friend ' +
                        'Lists, and LeaderBoards.  You can also choose ' +
                        'to use your Facebook profile name.' },

            { section:  'Profile',
              importance: 3,
              question: 'Which avatar picture should I choose?',
              answer:   'Go for it, choose an avatar picture to add ' +
                        'personality and color to your profile! Choose the ' +
                        appName + ' avatar that best matches your ' +
                        'personality. You can also choose to use your ' +
                        'Facebook profile picture. In either case, ' +
                        'your avatar will be shown on the LeaderBoard and ' +
                        'with any Score Comments you submit. If you do not ' +
                        'choose an avatar picture, a default one will be ' +
                        'used.' },

            { section:  'Profile',
              importance: 4,
              question: 'Are the User Settings optional?',
              answer:   'Yes.  However, if you fill out all the information, ' +
                        'it will help us better understand our users, and to ' +
                        'design features, offers, and rewards to match.  In ' +
                        'return, you will earn Mojo Points at twice the ' +
                        'normal values.  We do not share any personally ' +
                        'identifiable information with anyone for any ' +
                        'reason.' },

            { section:  'Profile',
              importance: 4,
              question: 'How are the User Preferences used?',
              answer:   'User Preferences are a convenient way to get to ' +
                        'the most interesting ' + appName + ' information ' +
                        'more quickly.  The next time you start the app, ' +
                        'your new preferences will be in effect.' },

            { section:  'Friends',
              importance: 1,
              question: 'What are ' + appName + ' Friends?',
              answer:   'Most everything is way more fun with Friends. ' +
                        appName + ' Friends are people that you have ' +
                        'invited to be on your Friends list, or vice versa. ' +
                        'You can compete with your Friends on your own ' +
                        'personal LeaderBoard, or collaborate on Score ' +
                        'submissions. You can also locate any of your ' +
                        'Friends that have recently checked in at a venue ' +
                        'nearby, or on your Favorites list.  So, be ' +
                        'social and invite friends to join you on ' +
                        appName  },

            { section:  'Friends',
              importance: 2,
              question: 'How do I add a ' + appName + ' Friend?',
              answer:   'It is very easy to add new Friends.  If your ' +
                        'friend is not yet a ' + appName + ' user, ' +
                        'choose Refer a Friend from the menu to send ' +
                        'them an email with instructions to get on ' +
                        'board.  If they are a current ' + appName + ' ' +
                        'user, then choose Friends from the menu, and ' +
                        'click on the +/- or edit button to send ' +
                        'them an invite.  When they accept, you will ' +
                        'have a new Friend on your list.' },

            { section:  'Friends',
              importance: 2,
              question: 'How do I remove a ' + appName + ' Friend?',
              answer:   'There are a few ways to remove a Friend.  The ' +
                        'first way it to not accept their invite before ' +
                        'you are Friends.  If they are already a Friend, ' +
                        'select Friends from the menu and click on the ' +
                        '+/- or edit button.  There you will see options ' +
                        'to remove users from your Friends list.  Lastly, ' +
                        'if you wish, you can Block a user by adding them ' +
                        'to your Block list.' },

            { section:  'Friends',
              importance: 3,
              question: 'How do I totally block a ' + appName + ' user?',
              answer:   'You can permanently block a user by adding them ' +
                        'to your Block list.  Just choose Friends from the ' +
                        'menu, navigate to the Blocked list, and click on ' +
                        'the +/- or edit button.  From there, you can ' +
                        'add or remove users from your Block list.  It is ' +
                        'permanent until you say otherwise.' },

            { section:  'Friends',
              importance: 4,
              question: 'What are Checkins?',
              answer:   'When submitting a Score, you can also check the ' +
                        'Checkin checkbox to let your Friends know where ' +
                        'you are, should they be interested.  You can see ' +
                        'your Friend Checkins on the List of Places, or by ' +
                        'looking at your Friends list.  It is great to join ' +
                        'Friends when the opportunity presents itself.  At ' +
                        appName + ', we are happy to help connect you!' },

            { section:  'Security',
              importance: 1,
              question: 'What is the ' + appName + ' privacy policy?',
              answer:   'The Privacy Policy is always available from the ' +
                        'About menu. Your private information will never be ' +
                        'shared with anyone!  Your email is a unique ' +
                        'username used for login.  Your phone number is only ' +
                        'used for extra verification purposes.  Neither will ' +
                        'be shared with anyone for any reason.'  },

            { section:  'Security',
              importance: 2,
              question: 'Why do you ask for my telephone number?',
              answer:   'Your telephone number is optional.  If provided ' +
                        'it will never be called and will never be shared ' +
                        'with anyone for any reason.  We send a single text ' +
                        'message with a click back link as a secondary way ' +
                        'to verify that you are an actual person and not a ' +
                        'robot or rogue program.  We plan to reward our ' +
                        'most active users and need to be sure they are ' +
                        'genuine and legitimate.' },

            { section:  'List / Map',
              importance: 1,
              question: 'What kind of Places are shown in the List or Map?',
              answer:   'By default, ' + appName + ' shows you the nearest ' +
                        '50 restaurants and bars, based on your current ' +
                        'location.  You can change the types of places ' +
                        'shown by choosing the Place Types option from ' +
                        'the menu.  Choose any combination of place types ' +
                        'of interest or choose All to find most any type ' +
                        'of establishment.' },

            { section:  'List / Map',
              importance: 2,
              question: 'How do I change the number of Places found?',
              answer:   'The nearest 50 places are found by default and ' +
                        'shown in the List or Map.  You can change that ' +
                        'number in the Place Types option under the menu. ' +
                        'You can choose between 10 and 100 places to find.' },

            { section:  'List / Map',
              importance: 3,
              question: 'How do I change the location to find places?',
              answer:   appName + ' uses your device\'s current location to ' +
                        'find places.  You can change the location by doing ' +
                        'a search on the Map and typing in the location of ' +
                        'interest, like Miami or Paris.  You can browse ' +
                        'faraway places, but you will only be able to ' +
                        'submit Scores within range of your current device ' +
                        'location. To return to your device location, just ' +
                        'hit the Home button on the Map in the upper right.' },

            { section:  'List / Map',
              importance: 4,
              question: 'What is the shaded circle on the Map?',
              answer:   'The Map is provided by Google and has the usual ' +
                        'zoom options.  If you zoom out far enough, you will ' +
                        'see a shaded circle on the Map.  The center of the ' +
                        'circle is your current search location.  The ' +
                        'outermost part of the circle is the distance to ' +
                        'the furthest place found in your search.  All of ' +
                        'places found should likely be inside the circle. ' +
                        'Keep in mind, the search is based on the closest ' +
                        'number of Places, and not a particular distance ' +
                        'from your current location. Be sensible though, ' +
                        'you may not find many laundromats in Antartica!' },

            { section:  'Scores',
              importance: 1,
              question: 'What can I do from the Score page?',
              answer:   'The Score page is dedicated to a single place of ' +
                        'interest. On the page, you can view the current ' +
                        'Score average, submit your own Score and Comment, ' +
                        'or just check out comments left by other users. ' +
                        'You can submit Scores anonymously or login and ' +
                        'earn Mojo Points for your Scores.  If you are ' +
                        'logged in, you can additionally submit comments, ' +
                        'check in to the location, and also choose to post ' +
                        'your score submission to Facebook.' },

            { section:  'Scores',
              importance: 1,
              question: 'Why should I submit a score?',
              answer:   'The primary purpose of ' +
                        utilities.getApplicationName() + ' ' +
                        'is to combine scores from all users to show ' +
                        'an average score for each place.  If no one ' +
                        'submits scores, that could be very difficult! ' +
                        'So, definitely! You should submit scores as ' +
                        'often as it\'s convenient and possible. ' +
                        'All of Humanity is counting on your scores! ' +
                        'Besides, you get Mojo Points for every score.' },

            { section:  'Scores',
              importance: 1,
              question: 'Which Score should I choose?',
              answer:   'Choose a Score which best represents how crowded ' +
                        'the selected place is, as you view it.  The ' +
                        'lowest Score means you are practically the only ' +
                        'person in the place.  The highest Score is for ' +
                        'the place that has a line out the door.  Choose ' +
                        'wisely, as other visitors will be depending on ' +
                        'your good judgement.' },

            { section:  'Scores',
              importance: 3,
              question: 'Should I leave a Score Comment?',
              answer:   'If you have a user account and are logged in, ' +
                        'you can submit Comments with your Scores.  Some ' +
                        'additional details from you might help others ' +
                        'better understand your Score.  For example, you ' +
                        'might say that you chose a Score of 4 because ' +
                        'the place is very very busy, but there is no line ' +
                        'at the door to get in.  Likewise, you can say ' +
                        'that you chose a 2 because the place is slow ' +
                        'but getting busier.  So, login and let everyone ' +
                        'benefit from your wisdom and guidance and leave ' +
                        'a descriptive Comment!  You also get more Mojo ' +
                        'Points for leaving a score comment.' },

            { section:  'Scores',
              importance: 3,
              question: 'How do I see past Score Comments?',
              answer:   'Good question.  At the bottom of the list of ' +
                        'recent comments, there is a button to show ' +
                        'more comments.  To get even older comments, ' +
                        'just keep clicking on the same button.  Any ' +
                        'score comment posted is viewable for several ' +
                        'weeks.  So, get creative!  Your words of wisdom ' +
                        'will be available for all of Humanity for some ' +
                        'time.' },

            { section:  'Scores',
              importance: 5,
              question: 'Do I really have to be at a place to submit Scores?',
              answer:   'Yes.  The whole idea behind ' + appName + ' is to '+
                        'report genuine Scores from real users at the Scene. ' +
                        'For that reason, Scores can only be submitted '    +
                        'for places found within your search range.  We '   +
                        'all depend upon our user\'s honesty.  We have ways ' +
                        'to detect and deal with those Scores that might '  +
                        'be stretching the truth.' },

            { section:  'Scores',
              importance: 5,
              question: 'How many Scores are included in the Score average?',
              answer:   'By default, only the last 30 minutes of Scores ' +
                        'submitted for a Place are included in the Score ' +
                        'average.  However, this can be set to as little ' +
                        'as the last 10 minutes to as much as the last 120 ' +
                        'minutes.  To change the setting, click on the ' +
                        'Place Types option on the menu and navigate to ' +
                        'Search Limits and select a new Time limit.' },

            { section:  'Mojo Points',
              importance: 1,
              question: 'What are Mojo Points?',
              answer:   'Mojo Points are earned every time you submit a ' +
                        'crowd score, comment, or checkin.  Other ' +
                        'actions are also rewarded with Mojo Points, e.g. ' +
                        'referring a friend to ' + appName + '.  Mojo ' +
                        'Points are used to show the most active ' +
                        appName + ' users on the Leaderboards and in ' +
                        'the future will play a role in the Merchant ' +
                        'Program to redeem offers, etc.  However, Mojo ' +
                        'Points do expire after 30 days.  So, keep ' +
                        'submitting those scores and DON\'T LOSE YOUR ' +
                        'MOJO!' },

            { section:  'Mojo Points',
              importance: 2,
              question: 'How do I get ' + appName + ' Mojo Points?',
              answer:   'There are several ways to get Mojo Points.  They ' +
                        'are awarded for submitting Scores, submitting ' +
                        'Comments, and referring new users, and double ' +
                        'points will be earned if your profile is fully ' +
                        'filled out.  From time to time, we will identify ' +
                        'new ways to get more Mojo Points.  We would love ' +
                        'to hear your creative ideas!' },

            { section:  'Mojo Points',
              importance: 3,
              question: 'Do ' + appName + ' Mojo Points expire?',
              answer:   'Yes.  Mojo Points expire about 30 days after you ' +
                        'earn them.  So, the Mojo Points you see are only ' +
                        'those you have earned in the last month.  So, keep ' +
                        'scoring and don\'t lose your Mojo!' },

            { section:  'Mojo Points',
              importance: 4,
              question: 'How are ' + appName + ' Mojo Points used?',
              answer:   'Mojo Points are used to measure activity and ' +
                        'loyalty. The most active users are recognized in ' +
                        'the LeaderBoards.  There are Leaderboards for ' +
                        'your Friends, your Favorite Places, and for your ' +
                        'geographic Areas.  The more Mojo Points you have, ' +
                        'the higher your ranking in the LeaderBoards.  ' +
                        'In addition to LeaderBoards, we are working on ' +
                        'other valuable ways to use your Mojo Points.  Stay ' +
                        'tuned!' },

            { section:  'Mojo Points',
              importance: 4,
              question: 'What are Mojo Point Levels?',
              answer:   'Mojo Point Levels reflect and recognize scoring ' +
                        'activity and achievement.  Achieving a higher Level ' +
                        'means you have been a more active user and more ' +
                        'experienced at Tracking the Herd.  Rewards ' +
                        'will be chosen based on Mojo Point Levels achieved. ' +
                        'The level names were chosen for experienced animal ' +
                        'herders, which is tongue-in-cheek analogous to ' +
                        'tracking crowds of people.  That\'s why our tag ' +
                        'line is... Track the Herd, and Don\'t lose your ' +
                        'Mojo!' },

            { section:  'Mojo Points',
              importance: 5,
              question: 'Where are my Mojo Points in the LeaderBoards?',
              answer:   'Mojo Points are currently awarded for submitting ' +
                        'scores and referring friends to ' + appName + '. ' +
                        'Your total points from all activity are shown on ' +
                        'the homescreen.  The LeaderBoards show Mojo Points ' +
                        'in the Places and Areas in which they were earned. ' +
                        '<br><br>' +
                        'If you submit a score for Town Pizza in Atlanta, ' +
                        'Georgia, you will see points awarded in the Place ' +
                        'LeaderBoard for Town Pizza.  If you made the top ' +
                        '10, you will see your name and all the scoring ' +
                        'points earned there.  Similarly, if you look at the ' +
                        'Area LeaderBoard for Georgia, you will see your ' +
                        'scoring points from all Places in Georgia.' +
                        '<br><br>' +
                        'Referral points are awarded in the Area in which ' +
                        'they were earned.  So, if your referral submits ' +
                        'their first score in Massachusetts, you will see ' +
                        'your referral points on the Area LeaderBoard for ' +
                        'Massachusetts.  Your total points are all there, ' +
                        'just spread out between various LeaderBoards where ' +
                        'they were earned.' +
                        '<br><br>' +
                        'Your Friends LeaderBoard shows your total points ' +
                        'relative to your fellow trackers, whom you have ' +
                        'deemed ' + appName + ' Friends.'},

            { section:  'Favorites',
              importance: 1,
              question: 'What are ' + appName + ' Favorites?',
              answer:   'Favorites are places in which you are frequently ' +
                        'interested.  While the List view shows every place ' +
                        'found in your search, Favorites will show only the ' +
                        'Places you have added to the Favorites list.  To ' +
                        'view the Favorites list, simply choose Favorites ' +
                        'from the menu.' },

            { section:  'Favorites',
              importance: 2,
              question: 'How can I add a Place to my Favorites List?',
              answer:   'You can add a Place to your Favorites List from ' +
                        'the Map or Score views.  In the Map view, select ' +
                        'the place of interest and click on the heart in ' +
                        'popup window.  From the Score view, you can also ' +
                        'click on the heart to add the current place to ' +
                        'your Favorites List.' },

            { section:  'Favorites',
              importance: 2,
              question: 'How can I remove a Place from my Favorites List?',
              answer:   'You can remove a Place from your Favorites List by ' +
                        'visiting the Favorites view and clicking on the ' +
                        'heart with an X on it.  You can also remove a ' +
                        'Favorite from the Map view by selecting the place ' +
                        'and clicking on the heart with an X on it in the ' +
                        'popup window.' },

            { section:  'Favorites',
              importance: 3,
              question: 'Can I add a faraway Place to my Favorites List?',
              answer:   'Yes.  You can do a Map search for Places outside ' +
                        'your immediate area.  Although you can add faraway ' +
                        'Places to your Favorites List, you will only be ' +
                        'able to submit Scores for Places in your immediate ' +
                        'area.  Scores are only valid for Places at which ' +
                        'you are located, or are very nearby.  Browsing ' +
                        'Scores and Score Comments from faraway places is ' +
                        'certainly OK and encouraged.  Adding such Places ' +
                        'to your Favorites List is a quick way to view them ' +
                        'without doing a full search.' },

            { section:  'LeaderBoards',
              importance: 1,
              question: 'What is a ' + appName + ' LeaderBoard?',
              answer:   'Mojo Points are awarded for various activities. ' +
                        'Users with the top 10 Mojo Points appear on the ' +
                        'LeaderBoards.  There are currently 3 types of ' +
                        'LeaderBoards, each with a different point of view. ' +
                        'There is a LeaderBoard for your Friends List, a ' +
                        'LeaderBoard for a particular Place of interest, ' +
                        'and a LeaderBoard for a specific geographic Area.' },

            { section:  'LeaderBoards',
              importance: 2,
              question: 'How can I select a Place LeaderBoard?',
              answer:   'From the menu, select LeaderBoards and Places. ' +
                        'Click on the +/- or edit button to see a list ' +
                        'of Places from your current map search and ' +
                        'Favorites List.  Choose one and you will see ' +
                        'the LeaderBoard for that Place.' },

            { section:  'LeaderBoards',
              importance: 2,
              question: 'How can I select an Area LeaderBoard?',
              answer:   'From the menu, select LeaderBoards and Areas. ' +
                        'Click on the +/- or edit button to see a list ' +
                        'of Areas from your current map search and ' +
                        'Favorites List.  Choose one and you will see ' +
                        'the LeaderBoard for that Area.  Being on top ' +
                        'of any Area LeaderBoard is definitely a special ' +
                        'achievement.' },

            { section:  'LeaderBoards',
              importance: 3,
              question: 'Why do I not see a Friends LeaderBoard?',
              answer:   'You will not see a Friends LeaderBoard unless ' +
                        'you are logged in.  Please check to make sure ' +
                        'you are successfully logged in and your account ' +
                        'is fully activated.' },

            { section:  'LeaderBoards',
              importance: 4,
              question: 'I do not see my recent points on the LeaderBoard!',
              answer:   'LeaderBoards are recalculated every few minutes. ' +
                        'So, just wait a bit and enjoy your hard earned ' +
                        'Mojo Points on the LeaderBoards.  Don\'t forget ' +
                        'though, Mojo Points expire after 30 days.  So, ' +
                        'keep Tracking the Herd and don\'t lose your Mojo!' },

            { section:  'My Map Places',
              importance: 1,
              question: 'Why would I want to create my own map place?',
              answer:   'The ' + utilities.getApplicationName() + ' map ' +
                        'is based on Google Maps, which can be searched ' +
                        'for businesses.  However, there are plenty of ' +
                        'places of interest which are not businesses.  ' +
                        'For example, a public basketball court, a house ' +
                        'party, or a Pokestop.  So, get creative and create ' +
                        'your own places which will show up on your friends ' +
                        utilities.getApplicationName() + ' map.' },

            { section:  'My Map Places',
              importance: 2,
              question: 'How can I create my own map place?',
              answer:   'It is very easy to create your own map place in ' +
                        'less than a minute.  Just select the menu item \'' +
                        'My Map Places\' and fill in the fields of interest ' +
                        'and hit Save.  In many cases, you only need to ' +
                        'fill in the name, address, and place types.  These ' +
                        'are the only required fields.  However you might ' +
                        'want to fill out the other fields, e.g. ' +
                        'description, so your visitors might get the most ' +
                        'out of your place and stop by more often.' },

            { section:  'My Map Places',
              importance: 3,
              question: 'Who can see my map places?',
              answer:   'You can choose to make your map place public or ' +
                        'private.  If you choose to make it public, ' +
                        'everyone can see it on their map, even anonymous ' +
                        'users.  This assumes they set their place types ' +
                        'to match your map place types.  You can also ' +
                        'choose to make you place private.  You have ' +
                        'options to make it private to your ' +
                        utilities.getApplicationName() + ' friends, your ' +
                        'Facebook friends, and/or a list of specific email ' +
                        'addresses.  To completely hide it from everyone, ' +
                        'you can make it private and choose to share it with ' +
                        'no one.' },

            { section:  'My Map Places',
              importance: 4,
              question: 'Can I delete my map place?',
              answer:   'Yes, you can delete any of the map places that ' +
                        'you create by choosing it from the list and ' +
                        'hitting the delete button.  However, you might ' +
                        'want to just make your places private as you ' +
                        'might need to make it visible in the future.' },

            { section:  'My Map Places',
              importance: 5,
              question: 'Can my map places be scored?',
              answer:   'Yes, absolutely!  Just like any other place, ' +
                        'scores can be submitted for your map place and ' +
                        'points earned will show up on the LeaderBoards.' },

            { section:  'My Map Places',
              importance: 6,
              question: 'Can users leave comments for my map places?',
              answer:   'Yes, for sure!  Part of the fun of having your ' +
                        'own map places is letting your friends leave ' +
                        'comments about their experience or just to say ' +
                        'hello.  Just like other map locations, comments ' +
                        'are preserved for 3 months.' },
            { section:  'My Map Places',
              importance: 7,
              question: 'How can I tell the difference between Google Maps ' +
                        'Places and My Map Places',
              answer:   'On the Map, you will notice that your map places ' +
                        'have a different style map marker.  Also, on the ' +
                        'bottom of the List, there are options to only ' +
                        'show Google Maps Places and/or User Created Places.' }
        ];

        // Get Server instance
        server = new Server();

        // Parameterize server faqs
        this.parameterizeServerFaq = function (serverFaq) {
            var appName = utilities.getApplicationName();
            serverFaq.section = serverFaq.section.replace(appName, 'APPNAME');
            serverFaq.question = serverFaq.question.replace(appName, 'APPNAME');
            serverFaq.answer = serverFaq.answer.replace(appName, 'APPNAME');
        };
    };


    // Public Prototype Methods

    // Fetch the client FAQs for display
    Faq.prototype.getClientFaqs = function () {
        return faqs.slice(0);
    };

    // Retrieve any server FAQs
    Faq.prototype.getServerFaqs = function(callback) {

        // Add standard headers
        var requestData = {};
        requestData['v'] = utilities.getApiVersion();
        requestData['command'] = utilities.getCommandCode('getFaqs');
        requestData['deviceId'] = utilities.getDeviceId();

        // Get only the current app FAQs
        requestData['appName'] = utilities.getApplicationName() || window.appName;

        // Submit
        var timeout = 15000;
        server.submit(requestData, timeout, function (response) {
            // Check the response and take appropriate action
            if (response) {
                // Good response
                if (response.status == returnCodes.getCode('SUCCESS_RC')) {
                    serverFaqs = response.faqs;
                    if (callback) {
                        callback(response);
                    }
                // Timeout
                } else if (response.timeout) {
                    // Try to continue with and empty list
                    if (callback) {
                        callback({});
                    }
                // Something bad happened
                } else {
                    if (response.communication) {
                        utilities.showAlert('ERROR: ' + response.communication);
                    }
                    if (callback) {
                        callback({});
                    }
                }
            }
        });
    };

    // Update server FAQs
    Faq.prototype.updateServerFaqs = function(updatedFaqs, callback) {

        // Parameterize on server APPNAME
        for (var i=0; i<updatedFaqs.length; i++) {
            this.parameterizeServerFaq(updatedFaqs[i]);
        }

        // Add standard headers
        var requestData = {};
        requestData['v'] = utilities.getApiVersion();
        requestData['command'] = utilities.getCommandCode('updateFaqs');
        requestData['deviceId'] = utilities.getDeviceId();
        requestData['faqs'] = updatedFaqs;

        // Submit
        var timeout = 15000;
        server.submit(requestData, timeout, function (response) {
            // Check the response and take appropriate action
            if (response) {
                // Good response
                if (response.status == returnCodes.getCode('SUCCESS_RC')) {
                    serverFaqs = response.faqs;
                    if (callback) {
                        callback(response);
                    }
                // Timeout
                } else if (response.timeout) {
                    // Try to continue with and empty list
                    if (callback) {
                        callback(response);
                    }
                // Something bad happened
                } else {
                    if (response.communication) {
                        utilities.showAlert('ERROR: ' + response.communication);
                    }
                    if (callback) {
                        callback({});
                    }
                }
            }
        });
    };

    // Return the constructor
    return Faq.prototype.constructor;
});

